import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AddEditAgencyType,
  ExamAgencyMode,
} from './enum/add-edit-exam-agency.enum';
import {
  IAddEditExamAgencyParam,
  IDropdownListCode,
  IExamAgencyResult,
} from './interface/exam-agency.interface';
import { BooleanUtil } from 'src/app/utils';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  IExamAgency,
  IExamAgencyRequest,
} from '../interfaces/exam-agency.interface';
import { AddEditExamAgencyService } from './services/add-edit-exam-agency.service';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';
import { ToastrService } from 'ngx-toastr';
import { mergeAll } from 'rxjs/operators';
import { combineLatest, forkJoin, of, zip } from 'rxjs';

@Component({
  selector: 'app-add-edit-exam-agency',
  templateUrl: './add-edit-exam-agency.component.html',
  styleUrls: ['./add-edit-exam-agency.style.css'],
})
export class AddEditExamAgencyComponent {
  public examAgencyMode: ExamAgencyMode;
  public countryCode: Array<IDropdownListCode> = [];
  public phoneCountryCode: Array<IDropdownListCode> = [];
  public examAgencyStatusType: Array<IDropdownListCode> = [];
  public stateCode: Array<IDropdownListCode> = [];
  public phoneNumberError = {
    code1: false,
    phone1: false,
    code2: false,
    phone2: false,
  };
  public initialFormData = '';
  isFormSubmitted: boolean = false;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly addEditExamAgencyService: AddEditExamAgencyService,
    private readonly toaster: ToastrService,
    private readonly router: Router
  ) {
    this.retrieveLoggedInUserId();
  }

  examAgencyRequestParam: IExamAgencyRequest = {
    loggedInUserId: '',
    examAgencyId: '',
  };
  addEditExamAgency = new FormGroup({
    LoggedinUserID: new FormControl(),
    Exam_Agency_Id: new FormControl(),
    Exam_Agency_Name: new FormControl('', [Validators.required]),
    Website_Address: new FormControl(),
    Exam_Agency_Status_Type_Code: new FormControl('', [Validators.required]),
    Exam_Agency_Status_Type_Name: new FormControl(),
    Primary_Phone_Country_Code: new FormControl(),
    Primary_Phone_Number: new FormControl(),
    Secondary_Phone_Country_Code: new FormControl(),
    Secondary_Phone_Number: new FormControl(),
    Agency_Description: new FormControl(),
    Address_Id: new FormControl(),
    Address_Line_1: new FormControl('', [Validators.required]),
    Address_Line_2: new FormControl(),
    Address_Line_3: new FormControl(),
    City_Name: new FormControl('', [Validators.required]),
    State_Code: new FormControl('', [Validators.required]),
    State_Name: new FormControl(),
    Country_Code: new FormControl('', [Validators.required]),
    Country_Name: new FormControl(),
    Postal_Code: new FormControl('', [Validators.required]),
  });

  ngOnInit() {
    this.checkExamModeEditOrAdd();
    this.getExamAgencyDetail();
    this.fetchDropDownList();
    this.initialFormData = JSON.stringify(this.addEditExamAgency.value);
  }

  private checkExamModeEditOrAdd() {
    const { type, examAgencyId } = this.route.snapshot
      .queryParams as IAddEditExamAgencyParam;
    this.examAgencyMode = type as ExamAgencyMode;

    this.examAgencyRequestParam.examAgencyId = examAgencyId;
  }

  getExamAgencyDetail() {
    if (!this.canMakeRequest()) {
      return;
    }

    if (!this.examAgencyRequestParam.examAgencyId) {
      return;
    }

    this.addEditExamAgencyService
      .getExamAgencyById<IExamAgency>(
        this.examAgencyRequestParam.loggedInUserId,
        this.examAgencyRequestParam.examAgencyId
      )
      .subscribe((data) => {
        this.patchDataInForm(data);
      });
  }
  private fetchDropDownList() {
    forkJoin([
      this.addEditExamAgencyService.getDropdownListCode('COUNTRY'),
      this.addEditExamAgencyService.getDropdownListCode(
        'EXAM_AGENCY_STATUS_TYPE'
      ),
      this.addEditExamAgencyService.getDropdownListCode('PHONE_COUNTRY_CODE'),
    ]).subscribe((elem) => {
      const [countryCode, examAgencyStatusTypeCode, phoneCountryCode] =
        elem as unknown as Array<Array<IDropdownListCode>>;
      this.countryCode = countryCode;
      this.examAgencyStatusType = examAgencyStatusTypeCode;
      this.phoneCountryCode = phoneCountryCode;
    });
  }

  getState(country: string) {
    this.addEditExamAgencyService
      .getState<IDropdownListCode>(country)
      .subscribe((elem) => {
        this.stateCode = elem;
      });
  }

  countryChange() {
    this.getState(this.addEditExamAgency.value.Country_Code);
    this.addEditExamAgency.get('State_Code')?.setValue('');

    const h = this.addEditExamAgency.value.Country_Code;

    if (h === 'EMPTY' || h === '' || h == null || h == undefined) {
      this.addEditExamAgency.get('Country_Code')?.setValue('');
    }
  }

  private patchDataInForm(examAgency: IExamAgency) {
    this.addEditExamAgency.patchValue({
      LoggedinUserID: this.examAgencyRequestParam.loggedInUserId,
      ExamAgencyID: this.examAgencyRequestParam.examAgencyId,
      ...examAgency,
    });

    this.initialFormData = JSON.stringify(this.addEditExamAgency.value);

    if (examAgency.Country_Code) {
      this.getState(examAgency.Country_Code);
    }

    if (this.examAgencyMode === ExamAgencyMode.VIEW) {
      this.addEditExamAgency.disable();
    }
  }

  onSubmit() {
    if (this.addEditExamAgency.invalid) {
      this.toaster.error('Please fill required field', 'Error');
      return false;
    }

    // Check For Phone Number validations
    if (this.phoneNumbersValidation()) {
      this.toaster.error(
        'Please fill required field for Phone Numbers',
        'Error'
      );
      return false;
    }

    // if (this.countryValidator()) {
    //   this.toaster.error(
    //     'Please fill required field for Country & State',
    //     'Error'
    //   );
    //   return false;
    // }

    let formValue: IExamAgency;

    if (this.examAgencyMode === ExamAgencyMode.ADD) {
      formValue = this.saveExamAgencyModel(
        AddEditAgencyType.CREATE,
        this.addEditExamAgency.value
      ) as unknown as IExamAgency;
      formValue.ExamAgencyID = null;
      this.addEditExamAgencyService
        .createExamAgency<IExamAgency, IExamAgencyResult>(formValue)
        .subscribe((elem) => {
          this.toaster.success('Saved Successfully', 'Success',{timeOut:500});
          this.isFormSubmitted = true;
          this.router.navigateByUrl('/Exam/ExamAgencies');
        });
    } else if (this.examAgencyMode === ExamAgencyMode.EDIT) {
      formValue = this.saveExamAgencyModel(
        AddEditAgencyType.UPDATE,
        this.addEditExamAgency.value
      ) as unknown as IExamAgency;

      this.addEditExamAgencyService
        .updateExamAgency<IExamAgency, IExamAgencyResult>(formValue)
        .subscribe((elem) => {
          this.toaster.success('Saved Successfully', 'Success',{timeOut:500});
          this.router.navigateByUrl('/Exam/ExamAgencies');
        });
    } else {
      formValue = {} as IExamAgency;
    }

    this.addEditExamAgency.markAsPristine();
    this.addEditExamAgency.markAsUntouched();

    return;
  }

  countryValidator() {
    return false;
  }

  private phoneNumbersValidation(): boolean {
    const {
      Primary_Phone_Country_Code,
      Primary_Phone_Number,
      Secondary_Phone_Country_Code,
      Secondary_Phone_Number,
    } = this.addEditExamAgency.value;
    let flag = false;

    if (
      (Primary_Phone_Country_Code || '').toString().trim() ||
      (Primary_Phone_Number || '').toString().trim()
    ) {
      const checkBothOfThem =
        (Primary_Phone_Country_Code || '').toString().trim() &&
        (Primary_Phone_Number || '').toString().trim();
      flag = checkBothOfThem ? false : true;

      if (!(Primary_Phone_Country_Code || '').toString().trim()) {
        this.phoneNumberError.code1 = true;
      }
      if (!(Primary_Phone_Number || '').toString().trim()) {
        this.phoneNumberError.phone1 = true;
      }

      if (flag) {
        return flag;
      }
    }

    if (
      (Secondary_Phone_Country_Code || '').toString().trim() ||
      (Secondary_Phone_Number || '').toString().trim()
    ) {
      const checkBothOfThem =
        (Secondary_Phone_Country_Code || '').toString().trim() &&
        (Secondary_Phone_Number || '').toString().trim();
      flag = checkBothOfThem ? false : true;

      if (!(Secondary_Phone_Country_Code || '').toString().trim()) {
        this.phoneNumberError.code2 = true;
      }
      if (!(Secondary_Phone_Number || '').toString().trim()) {
        this.phoneNumberError.phone2 = true;
      }

      if (flag) {
        return flag;
      }
    }

    return flag;
  }

  getError(formField: string) {
    return this.addEditExamAgency.get(formField)?.hasError('required') &&
      this.addEditExamAgency.get(formField)?.touched
      ? true
      : false;
  }

  clear() {
    const currentValues = this.addEditExamAgency.value;
    const isPristine = JSON.stringify(currentValues) === this.initialFormData;
    if (isPristine) {
      this.addEditExamAgency.markAsPristine();
    } else {
    }
    if (this.addEditExamAgency.dirty) {
      const flag = window.confirm('Do you want to save the changes');

      if (flag) {
        this.onSubmit();
      } else {
        this.router.navigateByUrl('/Exam/ExamAgencies');
      }
    } else {
      // this.addEditExamAgency.reset();
      this.router.navigateByUrl('/Exam/ExamAgencies');
    }
  }
  canDeactivate(): boolean {
    const currentValues = this.addEditExamAgency.value;
    const isPristine = JSON.stringify(currentValues) === this.initialFormData;

    if (isPristine) {
      this.addEditExamAgency.markAsPristine();
    } else {
    }
    if (this.addEditExamAgency.dirty && !this.isFormSubmitted) {
      const flag = window.confirm('Do you want to save the changes');

      if (flag) {
        this.onSubmit();
        return true;
      } else {
        return true;
      }
    }
    return true;
  }

  /**
   * Checking Guards for making internal request
   *
   * @returns boolean
   */
  private canMakeRequest() {
    return this.examAgencyRequestParam.loggedInUserId ? true : false;
  }

  /**
   * Get User id from Local Storage
   */
  retrieveLoggedInUserId() {
    const loggedInUserId = UserAuthDetails.getUserLoggedInId();

    if (!loggedInUserId)
      return this.toaster.error('Please Provide Logged in User Id', 'Error');

    this.examAgencyRequestParam.loggedInUserId = loggedInUserId;
    return null;
  }

  saveExamAgencyModel(type: AddEditAgencyType, examAgencyForm: IExamAgency) {
    if (type === AddEditAgencyType.CREATE) {
      return {
        LoggedinUserID: this.examAgencyRequestParam.loggedInUserId,
        ExamAgencyName: examAgencyForm.Exam_Agency_Name || '',
        WebsiteAddress: examAgencyForm.Website_Address || '',
        ExamAgencyStatusTypeCode:
          examAgencyForm.Exam_Agency_Status_Type_Code || '',
        PrimaryPhoneCountryCode:
          examAgencyForm.Primary_Phone_Country_Code || '',
        PrimaryPhoneNumber: examAgencyForm.Primary_Phone_Number || '',
        SecondaryPhoneCountryCode:
          examAgencyForm.Secondary_Phone_Country_Code || '',
        SecondaryPhoneNumber: examAgencyForm.Secondary_Phone_Number || '',
        AgencyDescription: examAgencyForm.Agency_Description || '',
        AddressLine1: examAgencyForm.Address_Line_1 || '',
        AddressLine2: examAgencyForm.Address_Line_2 || '',
        AddressLine3: examAgencyForm.Address_Line_3 || '',
        CityName: examAgencyForm.City_Name || '',
        StateCode: examAgencyForm.State_Code || '',
        CountryCode: examAgencyForm.Country_Code || '',
        PostalCode: examAgencyForm.Postal_Code || '',
      };
    } else if (type === AddEditAgencyType.UPDATE) {
      return {
        LoggedinUserID: this.examAgencyRequestParam.loggedInUserId || '',
        ExamAgencyID: examAgencyForm.Exam_Agency_Id || '',
        ExamAgencyName: examAgencyForm.Exam_Agency_Name || '',
        WebsiteAddress: examAgencyForm.Website_Address || '',
        ExamAgencyStatusTypeCode:
          examAgencyForm.Exam_Agency_Status_Type_Code || '',
        PrimaryPhoneCountryCode:
          examAgencyForm.Primary_Phone_Country_Code || '',
        PrimaryPhoneNumber: examAgencyForm.Primary_Phone_Number || '',
        SecondaryPhoneCountryCode:
          examAgencyForm.Secondary_Phone_Country_Code || '',
        SecondaryPhoneNumber: examAgencyForm.Secondary_Phone_Number || '',
        AgencyDescription: examAgencyForm.Agency_Description || '',
        AddressID: examAgencyForm.Address_Id || '',
        AddressLine1: examAgencyForm.Address_Line_1 || '',
        AddressLine2: examAgencyForm.Address_Line_2 || '',
        AddressLine3: examAgencyForm.Address_Line_3 || '',
        CityName: examAgencyForm.City_Name || '',
        StateCode: examAgencyForm.State_Code || '',
        CountryCode: examAgencyForm.Country_Code || '',
        PostalCode: examAgencyForm.Postal_Code || '',
      };
    }
    return;
  }

  preventEnteringString(event: KeyboardEvent, maxLen: number) {
    if (Number.isNaN(+event.key)) {
      return false;
    }

    if (((event.target as any)?.value || '').length > maxLen - 1) {
      return false;
    }

    return true;
  }

  // preventMaxLength(event: KeyboardEvent, maxLen: number) {}
}
